import { Bell, Settings } from "lucide-react";
import Aays from "../assets/img/AaysLogo.png";
import { Link } from "react-router-dom";

const HeaderContent = () => {
    const fullName = localStorage.getItem("userName") || "";

    const getInitials = (name) => {
        if (!name) return "";
        const parts = name.trim().split(" ");
        return parts.length === 1
            ? parts[0][0].toUpperCase()
            : (parts[0][0] + parts.at(-1)[0]).toUpperCase();
    };

    const getFirstLastName = (name) => {
        if (!name) return "";
        const parts = name.trim().split(" ");
        return parts.length === 1
            ? parts[0]
            : `${parts[0]} ${parts.at(-1)}`;
    };

    return (
        <>
            <div className="flex items-center gap-2">
                <img src={Aays} style={{width:"100px"}} />
            </div>

            <div className="flex items-center gap-4">
                <Bell className="w-4 h-4 cursor-pointer text-[#404040] " />
                <Link to={'/admin/control/userManagement'}>
                    <Settings className="w-4 h-4 cursor-pointer text-[#404040] " />
                </Link>

                <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-[#E12AFB] text-white flex items-center justify-center text-[11px]">
                        {getInitials(fullName)}
                    </div>
                    <span className="text-[12px] text-[#818181]">
                        {getFirstLastName(fullName)}
                    </span>
                </div>
            </div>
        </>
    );
};

export default HeaderContent;
